import { render } from "./TermsOfUse.vue?vue&type=template&id=7fd3ec76&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=7fd3ec76&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd3ec76"]])

export default __exports__